<template>
  <OwnStack el="span" class="w-full">
    <OwnType
      class="text--truncate"
      el="span"
      :text="cellText"
      :align="props.column.align"
      :color="props.column.body?.color"
      :variant="props.column.body?.font"
    />
  </OwnStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { OwnStack } from '../../OwnStack'
import { OwnType } from '../../OwnType'

import { OwnTableColumnConfig } from '../types'

const props = defineProps<{
  column: OwnTableColumnConfig
  item: object
}>()

const cellText = computed(() => {
  const itemKey = props.column.body?.key ?? props.column.key

  // @ts-expect-error Vue 2 doesn't support generics so I can't set up a proper keyof
  const itemValue = props.item[itemKey]

  if (props.column.body?.format)
    return props.column.body.format(itemValue as never)

  if (itemValue) return itemValue

  return '—'
})
</script>
